var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useReducer, useState } from 'react';
import { useRoute } from 'ziggy-js';
import SelectModelByBranch from '@/Jetstream/SelectModelByBranch';
import JetInputError from "../../../Jetstream/InputError";
import { useUnsavedChanges } from "@/Utils/handleUnsavedChanges";
import useForm from "@/Utils/useForm";
import StepLayout from "./StepLayout";
import { UserPlusIcon } from "@heroicons/react/24/outline";
import axios from 'axios';
import { Ziggy } from "@/ziggy";
import { VetCard, VetCardForm } from "@/Pages/Vet/Partials/VetCard";
import { Button } from "@/components/ui/button";
export default function VetStep(_a) {
    var certificate = _a.certificate, team = _a.team, branch = _a.branch, vetsByBranch = _a.vetsByBranch, vets = _a.vets;
    var route = useRoute(Ziggy);
    var _b = useReducer(function (x) { return x + 1; }, 0), ignored = _b[0], forceUpdate = _b[1];
    var _c = useState(false), editing = _c[0], setEditing = _c[1];
    var form = useForm(__assign(__assign({}, certificate), { _step: 1 }));
    var _d = useUnsavedChanges(form), handleUnsaved = _d[0], removeHandleUnsaved = _d[1];
    useEffect(function () {
        handleUnsaved();
        return function () {
            removeHandleUnsaved();
        };
    });
    function submit() {
        form.put(route('team.branch.certificate.update', { team: team, branch: branch, certificate: certificate }), {
            errorBag: 'updateBranch',
            preserveScroll: true,
        });
    }
    function createNewVet() {
        form.setData('vet', {});
        setEditing(true);
    }
    return (_jsxs(StepLayout, __assign({ team: team, branch: branch, certificate: certificate, form: form }, { children: [_jsxs("div", __assign({ id: "vet_select_holder" }, { children: [_jsx("div", __assign({ className: "".concat(vets.length === 0 ? 'hidden' : '') }, { children: _jsx(SelectModelByBranch, { label: "Assigned vet", team: team, branch: branch, itemsByBranch: vetsByBranch, items: branch.vets, selected: form.data.vet, singularText: "vet", relationship: "vets", onCreateClick: createNewVet, onChange: function (vet) {
                                console.log('SelectModelByBranch:onChange', vet);
                                form.setData('vet', vet);
                                setTimeout(function () { return forceUpdate(); }, 500);
                            } }) })), (vets.length === 0) && !editing && _jsx("div", { children: _jsxs("button", __assign({ id: "create_first_vet", className: "inline-flex items-center px-6 py-4 font-medium rounded-md shadow-sm hover:bg-green-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 disabled:opacity-25 transition border border-green-600 bg-white text-green-600", onClick: createNewVet }, { children: [_jsx(UserPlusIcon, { className: "w-4 h-4 inline-block mr-2" }), " Create your first vet"] })) })] })), _jsx(JetInputError, { message: form.errors.vet, className: "mt-2" }), _jsxs("div", __assign({ className: "mt-4" }, { children: [!editing && form.data.vet && _jsx(VetCard, { vet: form.data.vet, setEditing: setEditing }), editing && _jsx(VetCardForm, { vet: form.data.vet, setEditing: setEditing, onSave: function (data) {
                            setEditing(false);
                            form.setData('vet', data);
                        }, team: team, branch: branch })] })), _jsx(Button, __assign({ id: "continue", disabled: form.processing || editing, processing: form.processing, onClick: submit, className: "mt-6" }, { children: "Save & continue" }))] })));
}
export function saveVetForm(modelForm, form, team, branch) {
    var route = useRoute(Ziggy);
    var isCreate = !modelForm.data.id;
    var promise = !isCreate
        ? axios.put(route('team.branch.vet.update', {
            team: team,
            branch: branch,
            vet: modelForm.data.id
        }), __assign({ _modal: true }, modelForm.data))
        : axios.post(route('team.branch.vet.store', {
            team: team,
            branch: branch,
        }), __assign({ _modal: true }, modelForm.data));
    modelForm.setProcessing(true);
    promise.then(function (resp) {
        modelForm.setProcessing(false);
        modelForm.setData(__assign({}, resp.data));
        // onChange(resp.data);
        // setEditing(false);
        form.setData('vet', resp.data);
    }, function (err) {
        var _a, _b;
        console.error('err', err.response);
        modelForm.setErrors((_b = (_a = err.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.errors);
        modelForm.setProcessing(false);
    });
}
